<template>
    <footer>
        <creaditbar />
        <div class="copyright hidePc">
            <p>Copyright 2020. <br class="displaySS">The Japan Dietetic Association All rights reserved.</p>
        </div>
    </footer>
</template>

<script>
import creaditbar from '@/components/_credit.vue'

export default {
    components:{
        creaditbar
    }
}
</script>

<style lang="scss" scoped>
footer{
  width: 100%;
  padding-top: 200px;
  padding-bottom: 174px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  z-index: 1;
    @media #{$IE}{
        justify-content: space-between;
        max-width: 1280px;
        padding-left: 30px;
        padding-right: 30px;
        width: calc(100% - 60px);
    }
    @media #{$maxM}{
        padding-top: 160px;
        padding-bottom: 86px;
    }
    .copyright{
      p{
        font-size: 10px;
        letter-spacing: 0.05em;
        margin-top: 36px;
      }
    }
}
</style>